import classNames from "classnames";
import React, { ReactNode } from "react";

import { Variant } from "./types";

type Props = {
  variant: Variant;
  children?: ReactNode;
  className?: string;
};

const VARIANT_CLASS_NAMES: Record<Variant, string> = {
  cta: "pb-8 md:pb-0 md:col-span-1 lg:col-span-4",
  "cta-description": "gap-24 lg:col-span-7 lg:col-start-6 lg:columns-2",
  "left-image": "md:col-span-5 lg:col-span-4",
  "right-image": "md:col-start-8 lg:col-start-9  md:col-span-5 lg:col-span-4",
  "left-description":
    "pt-12 lg:col-span-4 md:col-span-5 lg:pt-0 lg:col-start-2 md:pl-8",
  "right-description":
    "pt-12 md:col-span-5 md:col-start-7 lg:col-start-6 lg:pt-20",
  "left-half": "lg:col-span-5",
  "right-half": "lg:col-start-7 lg:col-span-5",
  "left-half-offset": "lg:col-span-5 lg:col-start-2",
  "right-half-offset": "lg:col-span-5",
  "left-description-wide": "md:col-span-5",
  "right-image-wide": "md:col-start-8 md:col-span-5",
  "large-number": "md:col-span-6",
  "large-number-description": "pt-12 md:pt-28 md:col-span-5 md:col-start-7",
  "left-description-half": "md:col-span-5",
  "right-image-half": "md:col-start-6 md:col-span-7 md:pl-20",
  meta: "md:col-span-3 lg:col-span-2",
  post: "md:col-span-9 lg:col-span-6",
  relatedArticles: "md:col-start-4 md:col-span-8 lg:col-start-10 lg:col-span-3",
};

export const PageSectionColumn = (props: Props) => {
  const { children, className, variant } = props;

  return (
    <div className={classNames(VARIANT_CLASS_NAMES[variant], className)}>
      {children}
    </div>
  );
};
